// extracted by mini-css-extract-plugin
export default {"add-address-mobile__title":"add-address-mobile__title_YzU3SBxd"};